import { Directive, ElementRef, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appInfiniteScroll]'
})
export class InfiniteScrollDirective implements OnInit, OnDestroy {
  @Input() options: IntersectionObserverInit = {}; // Intersection Observer options
  @Output() scrolled = new EventEmitter<void>();   // Event emitted when scrolled

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.createObserver();
    console.log("DIRECTIVE");
    
  }

  private createObserver() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.scrolled.emit(); // Trigger the event when the target is visible
      }
    }, this.options);

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect(); // Clean up the observer on directive destruction
    }
  }
}
